<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- 仅缓存兑换积分商品列表 / 新建 / 向导编辑，其它路由照常销毁；编辑页 key 带 id 避免不同商品串数据 -->
      <keep-alive :max="15" include="InnerRedeemProductList,InnerRedeemProductAdd,InnerRedeemProductUpdate,PmsRealProductBackfill">
        <router-view :key="routerViewCacheKey" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    routerViewCacheKey() {
      const r = this.$route
      if (r.name === 'innerRedeemProductUpdate') {
        return `ir-update-${r.query.id || ''}`
      }
      if (r.name === 'innerRedeemProductPreview') {
        return `ir-preview-${r.query.id || ''}`
      }
      return r.fullPath
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue